import './salutemarket/style';
import FormStructure from './salutemarket/form_structure';

export default FormStructure;